module.exports = __webpack_public_path__ + "img/dongji_ps_17.620f4ab4.jpg";